// extracted by mini-css-extract-plugin
module.exports = {"hiring-team-div":"styles-module__hiring-team-div___3TtIg"};